import * as URL from '../../utility/url';
import * as Event from '../../events';
import {logout} from '../../services/authenticated';
import {getArticle} from './article';
import {getProduct} from './product';
//import * as GHPages from '../../config/ghpages';

class Homepage {
    constructor(pattern, data) {
        this.pattern = pattern;
        this.userData = data;
    }
    
    parseUrl(request) {
        return URL.parse('', request);
    }
    
    getComponent() {
        //let request;
        // this.parseUrl(this.pattern).then(req => {
        //     //request = req.toString().split('/');
        //     if (req == '/home/logout.html') {
        //         return this.logout();
        //     }
        // })
        // .catch(error => {});
        getArticle('view-article', this.pattern);
        getProduct('view-product', this.pattern);
    }
    
    logout() {
        const {uid} = this.userData;
        Event.loading(length => {
            if (length == 100) {
                return logout(uid);
            }
        });
    }
}

export default Homepage;